import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@klear/ui/lib/utils'
import type { StatusTone } from '@/app/receivables/fund-checks'

const TONES: Record<StatusTone, string> = {
  ok: 'bg-success/15 text-success',
  warn: 'bg-warning/15 text-warning',
  info: 'bg-info/15 text-info',
  bad: 'bg-danger/15 text-danger',
  neutral: 'bg-muted text-foreground'
}

export const StatusPill = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement> & { tone: StatusTone }>(
  ({ tone, className, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex h-[22px] items-center whitespace-nowrap rounded-full px-2 text-xs font-medium',
        TONES[tone],
        className
      )}
      {...props}
    />
  )
)
StatusPill.displayName = 'StatusPill'
